import React from 'react';
import PropTypes from 'prop-types';

// #5A5A5A
function IconRemove({ color = 'white', size = 24, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 6H5M5 6H21M5 6L5.00098 19.9995C5.00098 20.5299 5.21169 21.0387 5.58676 21.4137C5.96184 21.7888 6.47054 21.9995 7.00098 21.9995H17.001C17.5314 21.9995 18.0401 21.7888 18.4152 21.4137C18.7903 21.0387 19.001 20.5299 19.001 19.9995V5.99951M8.00098 5.99951V3.99951C8.00098 3.46908 8.21169 2.96037 8.58676 2.5853C8.96184 2.21023 9.47054 1.99951 10.001 1.99951H14.001C14.5314 1.99951 15.0401 2.21023 15.4152 2.5853C15.7903 2.96037 16.001 3.46908 16.001 3.99951V5.99951M9.99902 10.9995V16.9995M14.001 10.9995V16.9995" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconRemove.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconRemove;
